import {
  CheckCircle2,
  UserPlus,
  Clock,
  CalendarCheck,
  CalendarX,
  CalendarCog,
  ArrowRightLeft,
  Video,
  CreditCard,
  Megaphone,
  Ticket,
  Layers,
  Users,
  Ban,
  Gift,
} from "lucide-react";

const ICON_MAP: Record<
  string,
  { icon: React.ElementType; color: string; bg: string }
> = {
  registration_paid: {
    icon: CheckCircle2,
    color: "text-emerald-400",
    bg: "bg-emerald-400/10",
  },
  collab_invite: {
    icon: UserPlus,
    color: "text-blue-400",
    bg: "bg-blue-400/10",
  },
  waitlist_moved_off: {
    icon: Clock,
    color: "text-amber-400",
    bg: "bg-amber-400/10",
  },
  booking_approved: {
    icon: CalendarCheck,
    color: "text-emerald-400",
    bg: "bg-emerald-400/10",
  },
  booking_denied: {
    icon: CalendarX,
    color: "text-red-400",
    bg: "bg-red-400/10",
  },
  booking_changed: {
    icon: CalendarCog,
    color: "text-blue-400",
    bg: "bg-blue-400/10",
  },
  transfer_received: {
    icon: ArrowRightLeft,
    color: "text-violet-400",
    bg: "bg-violet-400/10",
  },
  transfer_resolved: {
    icon: ArrowRightLeft,
    color: "text-violet-400",
    bg: "bg-violet-400/10",
  },
  videos_published: {
    icon: Video,
    color: "text-pink-400",
    bg: "bg-pink-400/10",
  },
  payment_reminder: {
    icon: CreditCard,
    color: "text-amber-400",
    bg: "bg-amber-400/10",
  },
  announcement: {
    icon: Megaphone,
    color: "text-blue-400",
    bg: "bg-blue-400/10",
  },
  event_registration_paid: {
    icon: Ticket,
    color: "text-emerald-400",
    bg: "bg-emerald-400/10",
  },
  series_registration_paid: {
    icon: Layers,
    color: "text-emerald-400",
    bg: "bg-emerald-400/10",
  },
  staff_invitation: {
    icon: Users,
    color: "text-blue-400",
    bg: "bg-blue-400/10",
  },
  booking_cancelled: {
    icon: Ban,
    color: "text-red-400",
    bg: "bg-red-400/10",
  },
  student_unregistered: {
    icon: Ban,
    color: "text-red-400",
    bg: "bg-red-400/10",
  },
  gift_card_received: {
    icon: Gift,
    color: "text-pink-400",
    bg: "bg-pink-400/10",
  },
};

const DEFAULT_ICON = {
  icon: CheckCircle2,
  color: "text-on-dark-muted",
  bg: "bg-muted/50",
};

interface NotificationIconProps {
  type: string;
  isUnread: boolean;
}

export function NotificationIcon({ type, isUnread }: NotificationIconProps) {
  const config = ICON_MAP[type] || DEFAULT_ICON;
  const Icon = config.icon;

  return (
    <div
      className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-opacity ${
        config.bg
      } ${isUnread ? "opacity-100" : "opacity-50"}`}
    >
      <Icon className={`h-4 w-4 ${config.color}`} strokeWidth={2} />
    </div>
  );
}
